export default {
    mounted(el, binding) {
        el.clickOutsideEvent = function(event) {
            // check that click was outside the el and its children
            if (!(el === event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                if (typeof binding.value === 'function') {
                    binding.value(event);
                }
            }
        };
        // Use document (not body) with capture phase so the event fires
        // before any stopPropagation calls in child handlers
        document.addEventListener('click', el.clickOutsideEvent, true)
    },
    unmounted(el) {
        document.removeEventListener('click', el.clickOutsideEvent, true)
    },
}
